import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { sparseAssetSchema } from '@/asset/api/types';
import { z } from 'zod';

const validationErrorFieldSchema = z.object({
  fieldName: z.string(),
  error: z.string(),
  errorCode: z.number(),
});

const processedAssetDataSchema = z.object({
  serial: z.string(),
  index: z.number(),
  validatedAsset: sparseAssetSchema.nullable(),
  fieldsUpdated: z.record(z.boolean()).nullable(),
  errors: z.array(validationErrorFieldSchema),
});

export const uploadAssetDataResponseSchema = z.object({
  data: z.object({
    success: z.boolean(),
    items: z.array(processedAssetDataSchema),
    structureErrors: z.array(validationErrorFieldSchema),
  }),
});

export type AssetDataUploadResult = z.infer<
  typeof uploadAssetDataResponseSchema
>['data'];

export async function uploadAssetData(
  formData: FormData
): Promise<AssetDataUploadResult> {
  const url = '/v1/import/asset-data';
  const response = await api.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const parsed = await parseResponse(
    uploadAssetDataResponseSchema,
    response.data,
    {
      schemaName: 'UploadAssetData',
      endpoint: url,
    }
  );
  return parsed.data;
}
